import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import Controls from '../../../controls/Controls';
import { useForm, Form } from '../../../controls/useForm';

const initialFValues = {
  id: 0,
  conpanyId: '',
  name: '',
  description: '',
};


export default function AddProductCategoryForm(props) {
  const { addProductCategory, recordForEdit } = props;
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ('name' in fieldValues)
      temp.name = fieldValues.name ? '' : 'This field is required.';
    if ('description' in fieldValues)
      temp.description = fieldValues.description ? '' : 'Field is required';
    setErrors({
      ...temp,
    });
    if (fieldValues === values)
      return Object.values(temp).every((x) => x === '');
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      addProductCategory(values, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);



    const [holdBtn, setHoldBtn] = useState(true);

  useEffect(() => {
    // Check if file is selected
    if (values.name && values.description) {
      setHoldBtn(false);
    } else {
      setHoldBtn(true);
    }
  }, [values]);
  

  return (
    <Form onSubmit={handleSubmit}>
      <Controls.Inputs
        name="name"
        label="Name"
        value={values.name || ""}
        onChange={handleInputChange}
        error={errors.name}
      />

      <Controls.Inputs
        label="Description"
        name="description"
        value={values.description || ""}
        onChange={handleInputChange}
        error={errors.description}
      />
      <div>
        <Controls.Button disabled={holdBtn} type="submit" text="Submit" />
      </div>
    </Form>
  );
}
